import Button from '@rio-cloud/rio-uikit/Button';
import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import type { CustomStepType, NavigationProps } from '@/features/guidedTour/types';

import { trackTourStep } from '../utils/analytics';

const NAVIGATION_DELAY = 50;

export const CustomNavigation = ({ steps, currentStep, setCurrentStep }: NavigationProps) => {
    const navigate = useNavigate();

    const [isNavigating, setIsNavigating] = useState(false);

    const stepsLength = steps.length;

    const saveStep = useCallback(
        (step: number, navigationMethod: 'next' | 'prev' | 'dot') => {
            localStorage.setItem('lastStep', step.toString());

            trackTourStep(step, navigationMethod);
        },
        [steps, stepsLength]
    );

    const handleNavigation = (step: number, navigationMethod: 'next' | 'prev' | 'dot') => {
        setIsNavigating(true);
        saveStep(step, navigationMethod);
        navigate((steps[step] as CustomStepType).route);

        setTimeout(() => {
            setCurrentStep(step);
            setIsNavigating(false);
        }, NAVIGATION_DELAY);
    };

    const handlePrev = () => {
        if (currentStep > 0 && !isNavigating) {
            handleNavigation(currentStep - 1, 'prev');
        }
    };

    const handleNext = () => {
        if (currentStep < stepsLength - 1 && !isNavigating) {
            handleNavigation(currentStep + 1, 'next');
        }
    };

    return (
        <div className='display-flex justify-content-between margin-top-10'>
            <Button
                aria-label='prev button'
                onClick={handlePrev}
                disabled={currentStep === 0}
                style={{
                    visibility: currentStep === 0 ? 'hidden' : 'visible',
                }}
                className={`btn-muted ${currentStep === 0 ? 'text-color-gray' : 'text-color-black'}`}
            >
                <i className='uikit-icon icon-arrow-left' />
            </Button>
            <ul className='display-flex align-items-center flex-wrap padding-0 margin-0'>
                {Array.from({ length: stepsLength }, (_, i) => i).map(index => (
                    <li
                        className={`display-block margin-x-1 width-20 height-10 bg-color-secondary rounded overflow-hidden cursor-pointer
                ${index === currentStep ? 'bg-secondary' : 'bg-lighter'}`}
                        onClick={() => handleNavigation(index, 'dot')}
                        key={`navigation_dot_${index}`}
                        aria-label={`Go to step ${index + 1}`}
                    />
                ))}
            </ul>
            <Button
                aria-label='next button'
                onClick={handleNext}
                disabled={currentStep === stepsLength - 1}
                style={{
                    visibility: currentStep === stepsLength - 1 ? 'hidden' : 'visible',
                }}
                className={`btn-muted ${currentStep === stepsLength - 1 ? 'text-color-gray' : 'text-color-black'}`}
            >
                <i className='uikit-icon icon-arrow-right' />
            </Button>
        </div>
    );
};
